//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const curalate = angular.module('curalate');

  curalate.service('ToastNotificationService', [
    '$sce',
    'toastr',
    'toastrConfig',
    function(
            $sce,
            toastr,
            toastrConfig,
        ) {
      const toastsById = {};
      const vendId = function() { return _.uniqueId('toast'); };
      const defaultToastTemplate = toastrConfig.templates.toast;

      function popToast(method, args) {
        const id = args.id ?? vendId();
        if (args.options && args.options.toastTemplate) {
          toastrConfig.templates.toast = args.options.toastTemplate;
        }
        toastsById[id] = toastr[method](args.message, args.title, args.options);
        _(toastsById[id].scope.options).extend(args.options);

        // Add the type to the scope of the toast so the new template can properly flag UI with it
        toastsById[id].scope.type = args.type;

        toastrConfig.templates.toast = defaultToastTemplate;
        return id;
      }

      this.error = function(args) {
        return popToast('error', args);
      };

      this.success = function(args) {
        return popToast('success', args);
      };

      this.warning = function(args) {
        return popToast('warning', args);
      };

      this.info = function(args) {
        return popToast('info', args);
      };

      this.getToast = function(toastId) {
        return toastsById[toastId];
      };

      this.close = function(toastId) {
        if (toastId && toastsById[toastId]) {
          toastr.clear(toastsById[toastId]);
          delete toastsById[toastId];
        } else {
          toastr.clear();
        }
      };

      this.updateMessage = function(toastId, message) {
        const toast = toastsById[toastId];

        if (!toast) {
          return;
        }

        if (toast.scope.allowHtml) {
          toast.scope.message = $sce.trustAsHtml(message);
        } else {
          toast.scope.message = message;
        }
      };

      this.updateOptions = function(toastId, options) {
        const toast = toastsById[toastId];
        const optionsWithoutHtml = _(options).omit('title', 'message');

        if (!toast) {
          return;
        }

        if (options.options && options.options.allowHtml) {
          toast.scope.allowHtml = true;
          toast.scope.title = $sce.trustAsHtml(options.title);
          toast.scope.message = $sce.trustAsHtml(options.message);
        } else {
          toast.scope.title = options.title;
          toast.scope.message = options.message;
        }

        _(toast.scope).extend(optionsWithoutHtml);
      };
    }]);
})();
